<template>
  <div class="flex dialog-content multiple">
    <div class="left-content overflow-y no--sb">
      <div class="button-container" v-for="(data, idx) in stepData" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
          <span v-if="currentRoute === 'step1'"
                class="chip rounded"
                :style="{backgroundColor:data.hex}"></span>
          <span class="text">{{data.name}}</span>
          <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span>
        </button>
      </div>
    </div>

    <div class="right-content">
      <figure class="relative">
        <img class="oval" :src="currentImage(selectedItem)" alt="image">
        <div v-if="selectedItem && !applyRule(selectedItem.val).visible" class="flex align-center justify-center select-button rule-text">
          <div class="overlay"></div>
          <p class="warning">選択できません<br>{{applyRule(selectedItem.val).rule}}</p>
        </div>
        <transition name="slideUp">
          <div class="flex align-center justify-center select-button" v-if="selectedItem && applyRule(selectedItem.val).visible">
            <div class="overlay"></div>
            <button class="oval transition pointer" @click="selectItem()">選択</button>
          </div>
        </transition>
      </figure>
    </div>
  </div>
</template>

<script>
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";
export default {
  name: "DiType1",
  props:{stepData:Array},
  setup(){
    const {currentRoute, toggleSubDialog, storeItem, selectItem, selectedItem} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)

    return {currentRoute, toggleSubDialog, storeItem, selectItem, selectedItem, currentImage, applyRule}
  }
}
</script>

<style>
.dialog-content {
  height: calc(100% - 30px);
}
.dialog-content.multiple {
  padding: 30px 40px 0 40px;
}
.dialog-content > .left-content {
  width: 354px;
  height: calc(100% - 30px);
  min-width: 354px;
  padding: 10px 0;
}
.dialog-content > .left-content > h5.title {
  padding-left: 10px;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 10px;
  margin-top: 30px;
}
.dialog-content > .left-content > h5.title:first-child {
  margin-top: 0;
}
.dialog-content > .left-content > div.button-container {
  height: 44px;
  width: 100%;
  margin-bottom: 10px;
}
.dialog-content > .left-content > div.button-container:hover > button {
  border-color: #000;;
}
.dialog-content > .left-content > div.button-container:last-child {
  margin-bottom: 0;
}
.dialog-content > .left-content > div.button-container > button {
  width: 100%;
  border: 1px solid #d2dae2;
  height: 100%;
}
.dialog-content > .left-content > div.button-container > button.active {
  border-color: #000;
  background-color: #f5f6fa;
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
}
.dialog-content > .left-content > div.button-container > button > .chip {
  display: block;
  width: 30px;
  height: 30px;
}
.dialog-content > .left-content > div.button-container > button > .text {
  margin-left: 10px;
  font-size: .9rem;
}
.dialog-content > .left-content > div.button-container > button.active > .chip {
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
  border: 1px solid #dcdde1;
}
.dialog-content > .left-content > div.button-container > button > .detail {
  margin-left: auto;
  margin-right: 10px;
  top: 1px;
  font-size: .8rem;
  color: gray;
  position: relative;
}
.dialog-content > .left-content > div.button-container > button > .detail::after {
  position: absolute;
  content: "";
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  height: 1px;
  background-color: gray;
  width: 20px;
}
.dialog-content > .right-content {
  width: calc(100% - 354px);
  padding-left: 20px;
  padding-top: 10px;
}
.dialog-content > .right-content > figure {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.dialog-content > .right-content > figure > img {
  width: 100%;
}
.dialog-content > .right-content > figure > .select-button {
  position: absolute;
  bottom: 5px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  height: 60px;
  width: 100%;
  /*background-color: rgba(0, 0, 0, .2);*/
}
.dialog-content > .right-content > figure > .select-button > .overlay {
  position: absolute;
  bottom: 5px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  width: 100%;
  height: 90%;
  backdrop-filter: blur(3px);
  z-index: 1;
}
.dialog-content > .right-content > figure > .select-button > button {
  position: relative;
  z-index: 2;
  width: 124px;
  height: 40px;
  background-color: #1e272e;
  border: 1px solid #f5f6fa;
  color: #f5f6fa;
}
.dialog-content > .right-content > figure > .select-button > button:hover {
  transform: translateY(-3px);
}
.dialog-content > .right-content > figure > .rule-text > p.warning {
  position: relative;
  z-index: 2;
  padding: 10px 40px 40px 20px;
  font-size: .9rem;
}
</style>
